import {
  articleReadRequest,
  getArticlesReadResponse,
  getFollowingResponse,
  getUserProfileResponse,
  putUserNameRequest,
  putUserNameResponse,
  putUserSettingsRequest,
  putUserTipRequest,
} from "./user.dto";
import { apiV2 } from "./v2";

export const getUserProfileApi = apiV2("GET", "/user/profile").withResponse(getUserProfileResponse);

export const putUserSettingsApi = apiV2("PUT", "/user/settings").withRequest(putUserSettingsRequest);

export const putUserTipApi = apiV2("PUT", "/user/tips/:tipKey").withRequest(putUserTipRequest);

export const putUserNameApi = apiV2("PUT", "/user/name").withRequest(putUserNameRequest).withResponse(putUserNameResponse);

export const getFollowingApi = apiV2("GET", "/user/following").withResponse(getFollowingResponse);

export const getArticlesReadApi = apiV2("GET", "/user/articles/read").withResponse(getArticlesReadResponse);

export const markArticleReadApi = apiV2("PUT", "/user/articles/:alias/:articleId/read").withRequest(articleReadRequest);

export const markArticleUnreadApi = apiV2("DELETE", "/user/articles/:alias/:articleId/read").withRequest(articleReadRequest);
